import React, { useEffect } from "react";
import { Row, Col, Layout, Card, Table, Button, PageHeader, Statistic } from "antd";
import { fmtDateTime } from "../../../common/Utils";
import { AddVersionDlg } from "./AddVersionDlg";
import { DeleteOutlined, WarningOutlined } from "@ant-design/icons";
import { useAppVersions } from "../../../hooks/settings/useAppVersions";

export const AppVersions = () => {
  const {
    appVersion,
    androidList,
    iosList,
    refresh,
    delAppVersion,
    add,
    save,
    check,
    openEditDlg,
    saving,
    setOpenEditDlg,
    model,
    loading,
  } = useAppVersions();

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Version",
      dataIndex: "version",
      key: "name",
    },
    {
      title: "Force Update",
      dataIndex: "forceUpdate",
      key: "forceUpdate",
      render: (v) => (v ? "Yes" : "No"),
    },
    {
      title: "Date",
      dataIndex: "createDate",
      key: "createDate",
      render: fmtDateTime,
    },
    {
      title: "Notes",
      dataIndex: "notes",
      key: "notes",
    },
    {
      title: "",
      key: "actions",
      render: (_, r) => <DeleteOutlined onClick={() => delAppVersion(r.id)} />,
    },
  ];

  useEffect(() => refresh(), []);

  return (
    <Layout.Content>
      <PageHeader title="App Version Info">
        <Row>
          <Statistic
            title="Android"
            prefix={appVersion.androidForceUpdate ? <WarningOutlined /> : null}
            value={appVersion.androidVersion}
            style={{
              marginRight: 32,
            }}
          />
          <Statistic
            title="IOS"
            prefix={appVersion.iosForceUpdate ? <WarningOutlined /> : null}
            value={appVersion.iosVersion}
          />
        </Row>
      </PageHeader>

      <div className="padding24">
        <Row gutter={20}>
          <Col span={12}>
            <Card title="Android" extra={<Button onClick={() => add("android")}>New Android Version</Button>}>
              <Table loading={loading} columns={columns} dataSource={androidList}></Table>
            </Card>
          </Col>
          <Col span={12}>
            <Card title="IOS" extra={<Button onClick={() => add("ios")}>New IOS Version</Button>}>
              <Table loading={loading} columns={columns} dataSource={iosList}></Table>

              <AddVersionDlg
                open={openEditDlg}
                close={() => setOpenEditDlg(false)}
                model={model}
                check={check}
                save={save}
                saving={saving}
              ></AddVersionDlg>
            </Card>
          </Col>
        </Row>
      </div>
    </Layout.Content>
  );
};
